import React from 'react'
import { Actionable, Container, Icon, Modal, Text, useToggle, View } from 'reshaped/bundle'
import { useRouter } from 'next/router'
import { ApplicationFooter } from 'experiences/search/Application/components/Footer'
import { ApplicationHeader } from 'experiences/search/Application/components/Header'
import { useAuthState } from 'services/Authentication'
import { GoTo } from 'ui/inputs/GoTo'
import { Button } from 'ui/inputs/Button/LegacyButtonCompatibility'
import { CloseIcon } from './assets/CloseIcon'

interface Props {
	onBack: () => void
	onExit?: () => void
	progress?: number
	enableBack?: boolean
	enableSave?: boolean
}

export const ApplicationLayout: React.FC<React.PropsWithChildren<Props>> = ({
	children,
	onBack,
	onExit,
	progress,
	enableBack = true,
	enableSave = true
}) => {
	const router = useRouter()
	const { userType } = useAuthState()
	const { active, activate, deactivate } = useToggle(false)
	let leftCTA = undefined
	let rightCTA = undefined

	if (onExit && enableSave) {
		if (userType === 'loggedIn') {
			rightCTA = (
				<GoTo direction="none" onClick={onExit} color="white">
					Save & Exit
				</GoTo>
			)
		} else {
			rightCTA = (
				<GoTo direction="none" color="white" onClick={activate}>
					Save & Exit
				</GoTo>
			)
		}
	}

	if (enableBack) {
		leftCTA = (
			<GoTo direction="left" color="white" onClick={onBack}>
				Back
			</GoTo>
		)
	}

	return (
		<>
			<View attributes={{ style: { minHeight: '100vh' } }}>
				<ApplicationHeader leftCTA={leftCTA} rightCTA={rightCTA} progress={progress || 0} />
				<View.Item grow>
					<div style={{ height: '104px' }} /> {/* add space for fixed header */}
					<Container width="1280px">{children}</Container>
				</View.Item>
				<Container width="1280px">
					<ApplicationFooter />
				</Container>
			</View>
			<Modal active={active} onClose={deactivate} size="600px" padding={8}>
				<View direction="row" justify="end" paddingBottom={6}>
					<Actionable onClick={deactivate}>
						<Icon svg={CloseIcon} size={6} />
					</Actionable>
				</View>
				<View direction="column" gap={8} justify="center" align="center">
					<Text variant="title-6" align="center">
						Save your progress by creating a free Fiona Account.
					</Text>
					<Button onClick={() => router.push('/account/register?utm_campaign=native-loans')}>Create Account</Button>
					<Actionable onClick={onExit}>
						<Text
							as="span"
							variant="body-1"
							align="center"
							color="positive"
							weight="bold"
							attributes={{ style: { textDecoration: 'underline', cursor: 'pointer' } }}
						>
							Not now
						</Text>
					</Actionable>
				</View>
			</Modal>
		</>
	)
}
